export const scannedPageSx = {
  urlSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-primary)',
    whiteSpace: 'normal', // Allows wrapping
    wordBreak: 'break-all', // Breaks long words or URLs
    overflowWrap: 'break-word', // Fallback for better wrapping
    minWidth: '400px'
  },
  scoreSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-near-black)'
  },
  learnText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'rgba(31, 37, 42, 1)'
  },
  watchTutorialBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    mt: 1,
    cursor: 'pointer'
  },
  img: {
    marginTop: '2.5px'
  }
};
